(function () {
    'use strict';

    a3_pilot_reports.controller('CrewCallCtrl', CrewCallCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name CrewCallCtrl
    * @description 
    *   View confirmation warning when clicking on a crew member's telephone - Monitor call requests
    * @ngInject
    */
    function CrewCallCtrl($scope, $uibModalInstance, crew, flightId, groundDutyId, CrewCallFactory, UserFactory, LogCallFactory) {

        $scope.close = close;
        $scope.call = call;
        $scope.beforeCall = true;
        $scope.crewFixed = null;
        if(crew.id) {
            $scope.crewFixed = crew;
        }
        else {
            $scope.crewFixed = {
                id: crew.Id,
                name: crew.Name,
                PhoneNumber: crew.PhoneNumber
            }
        }

        /**
         * Close the modal
         */
        function close() {
            $uibModalInstance.close(false);
        }

        /**
         * Confirm Call
         * @param {number} crewId Requested user 
         */
        function call() {
            $scope.beforeCall = false;
            var user = UserFactory.getUser();

            var logData = {
                Requester: user.id,
                Requestee: $scope.crewFixed.id,
                FlightId: flightId,
                GroundDutyId: groundDutyId,
                Date: moment.utc()
            };

            if ($scope.isOffline) {
                //Offline: save audit to local storage, send later on sync
                LogCallFactory.saveLogCall(logData);
            }
            else {
                //Online : API call to save audit right now
                CrewCallFactory.LogCall(logData, function (responseData) { });
            }
        }
    }

})();